import Helper from '../../../models/Helper';

const URI = '/external-resources/:id';

/**
 * @desc Helper for external-resources.
 */
class ExternalResourcesHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }
}

export default ExternalResourcesHelper;
